var _defs, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _line, _text, _circle, _line2, _text2, _circle2, _rect, _text3, _circle3, _line3, _rect2, _line4, _text4, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIvm3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d5ddeb;}.cls-2,.cls-5{fill:#812990;}.cls-3{fill:#fff;}.cls-4,.cls-6{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-5{font-size:8px;font-family:ProximaNova-Regular, Proxima Nova;}.cls-6{stroke-dasharray:2 2;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "418.71 88.89 50.2 88.89 50.2 346.85 263.93 346.85 418.71 88.89"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.6 346.85 308.15 162.59 418.71 346.85 197.6 346.85"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.58 402.1 234.43 346.83 50.18 346.83 50.18 402.1 197.58 402.1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.16,391.46v.72H87v-4.07h3v.72h-2.2v1h1.85v.69H87.83v.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.52,387.83v4.35h-.81V392a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.24,1.81,1.81,0,0,1,.91.24v-1.4Zm-.81,3.4V390a1.18,1.18,0,0,0-.76-.26.9.9,0,0,0-.94.9.88.88,0,0,0,.94.89A1.14,1.14,0,0,0,93.71,391.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.86,389.05v3.13h-.8V392a1.53,1.53,0,0,1-.86.25c-.91,0-1.34-.42-1.34-1.44v-1.73h.81v1.73c0,.49.23.72.68.72a1.11,1.11,0,0,0,.71-.24v-2.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103,391.6a1.5,1.5,0,0,1-1.21.62,1.62,1.62,0,1,1,0-3.23,1.54,1.54,0,0,1,1.23.62l-.52.48a.87.87,0,0,0-.71-.38.9.9,0,1,0,0,1.79.87.87,0,0,0,.71-.38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.37,389.05v3.13h-.8V392a1.66,1.66,0,0,1-.92.27,1.62,1.62,0,0,1,0-3.24,1.93,1.93,0,0,1,.92.26v-.19Zm-.8.93a1.21,1.21,0,0,0-.78-.27.9.9,0,1,0,0,1.79,1.24,1.24,0,0,0,.78-.26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.73,389.71v1.11c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2,2,0,0,1-.72.11.9.9,0,0,1-1-1v-1.53h-.45v-.66h.45v-1.22h.81v1.22h.87v.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.73,388.24a.47.47,0,0,1,.46-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,111.73,388.24Zm.07.81h.8v3.13h-.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.27,390.61a1.72,1.72,0,1,1-1.71-1.62A1.66,1.66,0,0,1,117.27,390.61Zm-.79,0a.93.93,0,1,0-.92.89A.91.91,0,0,0,116.48,390.61Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.48,390.43v1.75h-.8v-1.75c0-.48-.24-.72-.68-.72a1,1,0,0,0-.7.25v2.22h-.8v-3.13h.8v.19a1.49,1.49,0,0,1,.84-.25C121.06,389,121.48,389.42,121.48,390.43Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.84,390.37a6.83,6.83,0,0,1-.62.93l.49.48-.48.44-.45-.44a1.78,1.78,0,0,1-1.08.44c-.94,0-1.54-.43-1.54-1.18A1.23,1.23,0,0,1,126,390a1.08,1.08,0,0,1,.78-1.88,1.06,1.06,0,0,1,1.16,1,1.22,1.22,0,0,1-.88,1.11l.7.67a4.31,4.31,0,0,0,.48-.67Zm-1.48,1-.91-.89c-.33.13-.49.34-.49.57s.28.57.77.57A1,1,0,0,0,127.36,391.33Zm-1-2.14a.81.81,0,0,0,.36.58c.26-.08.6-.26.6-.59a.49.49,0,0,0-.49-.53A.5.5,0,0,0,126.33,389.19Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.52,388.11h.9l-1.9,4.07h-.38l-1.89-4.07h.89l1.19,2.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.44,388.24a.46.46,0,1,1,.46.47A.46.46,0,0,1,137.44,388.24Zm.06.81h.8v3.13h-.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.83,391.33a2.5,2.5,0,0,0,1.08.25c.37,0,.51-.13.51-.3s-.18-.26-.66-.36c-.68-.15-1.17-.37-1.17-1s.47-1,1.2-1a3.11,3.11,0,0,1,1.22.25l-.27.59a3,3,0,0,0-1-.2c-.31,0-.46.11-.46.28s.19.25.69.35c.73.15,1.15.41,1.15,1s-.46,1-1.26,1a2.74,2.74,0,0,1-1.36-.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.52,389.05v3.13h-.81V392a1.66,1.66,0,0,1-.92.27,1.62,1.62,0,0,1,0-3.24,1.89,1.89,0,0,1,.92.26v-.19Zm-.81.93a1.16,1.16,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.19,1.19,0,0,0,.77-.26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.54,391c0,.79-.63,1.25-1.58,1.25a3.09,3.09,0,0,1-1.69-.39l.3-.64a2.88,2.88,0,0,0,1.42.31c.45,0,.71-.16.71-.46s-.27-.39-.86-.53c-.84-.19-1.52-.43-1.52-1.23s.58-1.22,1.5-1.22a4,4,0,0,1,1.56.32l-.33.66a3.59,3.59,0,0,0-1.24-.27c-.42,0-.65.19-.65.44s.29.41.9.55C152.94,390,153.54,390.24,153.54,391Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.44,390.84a.87.87,0,0,0,.9.7,1,1,0,0,0,.8-.39l.52.43a1.73,1.73,0,0,1-1.42.64,1.62,1.62,0,0,1,0-3.23,1.5,1.5,0,0,1,1.53,1.67c0,.06,0,.13,0,.18Zm0-.51H157a.69.69,0,0,0-.76-.7A.81.81,0,0,0,155.45,390.33Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.8,389.48a1.19,1.19,0,0,1,1-.49l.2,0v.87a2.65,2.65,0,0,0-.39,0,.75.75,0,0,0-.8.82v1.51H159v-3.13h.81Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.28,389.05l-1.5,3.13h-.38l-1.51-3.13h.85l.85,1.77.85-1.77Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.35,388.24a.46.46,0,0,1,.46-.47.47.47,0,0,1,0,.94A.46.46,0,0,1,166.35,388.24Zm.06.81h.8v3.13h-.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.39,391.6a1.52,1.52,0,0,1-1.21.62,1.62,1.62,0,1,1,0-3.23,1.51,1.51,0,0,1,1.22.62l-.52.48a.86.86,0,0,0-.7-.38.9.9,0,1,0,0,1.79.86.86,0,0,0,.7-.38Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.16,390.84a.87.87,0,0,0,.9.7,1,1,0,0,0,.81-.39l.51.43a1.73,1.73,0,0,1-1.42.64,1.62,1.62,0,0,1,0-3.23,1.5,1.5,0,0,1,1.53,1.67c0,.06,0,.13,0,.18Zm0-.51h1.55a.69.69,0,0,0-.76-.7A.81.81,0,0,0,173.17,390.33Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.84,391.33a2.47,2.47,0,0,0,1.08.25c.37,0,.51-.13.51-.3s-.18-.26-.66-.36c-.68-.15-1.17-.37-1.17-1s.47-1,1.2-1a3.11,3.11,0,0,1,1.22.25l-.27.59a3,3,0,0,0-1-.2c-.31,0-.46.11-.46.28s.19.25.69.35c.73.15,1.15.41,1.15,1s-.46,1-1.26,1a2.72,2.72,0,0,1-1.36-.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.33,357.15h-.77v2.18h-.45v-2.18h-.77v-.45h2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.16,356.7v2.63h-.45v-1.86l-.87,1.34-.87-1.34v1.86h-.45V356.7H177l.83,1.28.83-1.28Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107,363.53v.85a5.75,5.75,0,0,0-1.49-.81,5.56,5.56,0,0,0-1.94-.32,5.85,5.85,0,0,0-2.27.44,5.55,5.55,0,0,0-1.79,1.19,5.65,5.65,0,0,0,0,7.91,5.39,5.39,0,0,0,1.79,1.19,5.85,5.85,0,0,0,2.27.44h.22a6.22,6.22,0,0,0,2.29-.43v-3a3.44,3.44,0,0,1-1.05.66,3.4,3.4,0,0,1-1.23.23,3,3,0,0,1-.52-.05h0a3.16,3.16,0,0,1-.72-.18,2.94,2.94,0,0,1-1-.66,2.93,2.93,0,0,1,0-4.3,2.94,2.94,0,0,1,1-.66,3.29,3.29,0,0,1,1.24-.23,3.18,3.18,0,0,1,2.28.89,2.87,2.87,0,0,1,.93,2.16v5.57h2.68V363.53Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.64,374.42l-5.93-5.73v5.73H87V359.33h2.68V365l5.93-5.68h3.79l-7.83,7.51,7.83,7.55Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.61,363.25a4.78,4.78,0,0,1,2,.4,4.48,4.48,0,0,1,1.52,1.08,4.82,4.82,0,0,1,1,1.59,5.27,5.27,0,0,1,.35,1.95v6.15h-2.68v-6.15a2.24,2.24,0,0,0-.78-1.75,2.54,2.54,0,0,0-1.83-.72,2.61,2.61,0,0,0-1.85.72,2.34,2.34,0,0,0-.76,1.75v6.15h-2.67V363.55h2.67v.81a5.47,5.47,0,0,1,1.37-.8A4.54,4.54,0,0,1,116.61,363.25Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.89,363.55a4.85,4.85,0,0,1,1.8-.32v2.54a3.2,3.2,0,0,0-2.28.89,3,3,0,0,0-.93,2.16v5.6H148.8V363.53h2.68v.83A5.41,5.41,0,0,1,152.89,363.55Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.74,363.25a6.07,6.07,0,0,1,4.17,1.63,5.74,5.74,0,0,1,1.27,1.78,5.36,5.36,0,0,1,.45,2.19,5.29,5.29,0,0,1-.45,2.16,5.74,5.74,0,0,1-1.27,1.78A5.85,5.85,0,0,1,163,374a6.21,6.21,0,0,1-4.59,0,5.68,5.68,0,0,1-3.14-3,5.3,5.3,0,0,1-.46-2.16,5.37,5.37,0,0,1,.46-2.19,5.88,5.88,0,0,1,1.26-1.78,6.08,6.08,0,0,1,1.88-1.19A6,6,0,0,1,160.74,363.25Zm0,2.55a3.14,3.14,0,0,0-2.27.89,2.93,2.93,0,0,0,0,4.3,2.89,2.89,0,0,0,1,.66,3.4,3.4,0,0,0,2.46,0A3.21,3.21,0,0,0,163,371a2.93,2.93,0,0,0,0-4.3A3.26,3.26,0,0,0,160.74,365.8Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.27,363.25a6.08,6.08,0,0,1,2.3.44,6.15,6.15,0,0,1,1.87,1.19,5.55,5.55,0,0,1,1.26,1.78,5.37,5.37,0,0,1,.46,2.19,5.3,5.3,0,0,1-.46,2.16,5.55,5.55,0,0,1-1.26,1.78,6,6,0,0,1-1.87,1.19,6.23,6.23,0,0,1-4.6,0,5.85,5.85,0,0,1-1.87-1.19,5.55,5.55,0,0,1-1.26-1.78,5.14,5.14,0,0,1-.46-2.16,5.21,5.21,0,0,1,.46-2.19,5.55,5.55,0,0,1,1.26-1.78,6.07,6.07,0,0,1,4.17-1.63Zm0,2.55a3.18,3.18,0,0,0-2.28.89,3,3,0,0,0,0,4.3,3.07,3.07,0,0,0,1,.66,3.45,3.45,0,0,0,1.24.23,3.4,3.4,0,0,0,1.23-.23,3.28,3.28,0,0,0,1-.66,2.93,2.93,0,0,0,0-4.3A3.24,3.24,0,0,0,173.27,365.8Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.64,363.53v.85a5.75,5.75,0,0,0-1.49-.81,5.6,5.6,0,0,0-1.94-.32,5.81,5.81,0,0,0-2.27.44,5.55,5.55,0,0,0-1.79,1.19,5.62,5.62,0,0,0,0,7.91,5.39,5.39,0,0,0,1.79,1.19,5.81,5.81,0,0,0,2.27.44h.22a6.16,6.16,0,0,0,2.28-.43v-3a3.28,3.28,0,0,1-1,.66,3.4,3.4,0,0,1-1.23.23,3,3,0,0,1-.52-.05h0a2.92,2.92,0,0,1-.72-.18,3.07,3.07,0,0,1-1-.66,3,3,0,0,1,0-4.3,3.07,3.07,0,0,1,1-.66,3.29,3.29,0,0,1,1.24-.23,3.14,3.14,0,0,1,2.27.89,2.84,2.84,0,0,1,.94,2.16v5.57h2.68V363.53Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.67,363.53v.85a5.66,5.66,0,0,0-1.5-.81,4.75,4.75,0,0,0-1-.24,6,6,0,0,0-1.15-.1,5.6,5.6,0,0,0-2.22.44,5.44,5.44,0,0,0-1.74,1.19,5.66,5.66,0,0,0-1.12,1.78,5.86,5.86,0,0,0-.4,2.18h0v0a5.55,5.55,0,0,0,1.6,3.94A5.54,5.54,0,0,0,126,374a5.76,5.76,0,0,0,2.26.44h.39a6.2,6.2,0,0,0,2.12-.42v-3a3.21,3.21,0,0,1-1,.66,3.36,3.36,0,0,1-1.23.23,2.94,2.94,0,0,1-.51-.05h0a2.92,2.92,0,0,1-.72-.18,3,3,0,0,1-1-.66,2.91,2.91,0,0,1-.94-2.15,3,3,0,0,1,.22-1.13l0-.09a3,3,0,0,1,.68-.93,3,3,0,0,1,1-.66,3.2,3.2,0,0,1,1.23-.23,3.15,3.15,0,0,1,2.28.89,3,3,0,0,1,.68.93l0,.09a3,3,0,0,1,.22,1.14v4.23a2.85,2.85,0,0,1-.94,2.14,3.29,3.29,0,0,1-3.88.49l-1.94,1.82a6.05,6.05,0,0,0,5.84.7,6.13,6.13,0,0,0,1.88-1.21,5.64,5.64,0,0,0,1.26-1.78,5.22,5.22,0,0,0,.45-2.16v-9.55Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.14,383.63v.71H87v-4h3V381H87.83v1h1.83v.69H87.83v.91Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.28,380v4.34h-.81v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.92,1.92,0,0,1,.91.23V380Zm-.81,3.4v-1.26a1.18,1.18,0,0,0-.76-.26.9.9,0,1,0,0,1.79A1.21,1.21,0,0,0,94.47,383.35Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.38,381.17v3.12h-.8v-.2a1.49,1.49,0,0,1-.85.25c-.91,0-1.33-.43-1.33-1.44v-1.73h.8v1.73c0,.49.23.72.67.72a1,1,0,0,0,.71-.25v-2.2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.3,383.71a1.48,1.48,0,0,1-1.21.63,1.62,1.62,0,1,1,0-3.23,1.51,1.51,0,0,1,1.22.63l-.51.47a.87.87,0,0,0-.71-.38.9.9,0,1,0,0,1.79.87.87,0,0,0,.71-.38Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.42,381.17v3.12h-.8v-.23a1.6,1.6,0,1,1-.91-2.95,1.76,1.76,0,0,1,.91.26v-.2Zm-.8.93a1.22,1.22,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.19,1.19,0,0,0,.77-.26Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.56,381.83v1.11c0,.55.09.72.49.72a3.7,3.7,0,0,0,.37,0v.59a1.71,1.71,0,0,1-.72.12.9.9,0,0,1-1-1v-1.53h-.44v-.66h.44V380h.81v1.21h.87v.66Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.34,380.41a.47.47,0,0,1,.46-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,116.34,380.41Zm.06.81h.8v3.12h-.8Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.64,382.73a1.71,1.71,0,1,1-1.71-1.62A1.66,1.66,0,0,1,122.64,382.73Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,121.85,382.73Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.62,382.6v1.74h-.8V382.6c0-.49-.24-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.8v-3.12h.8v.19a1.46,1.46,0,0,1,.84-.25C127.2,381.16,127.62,381.59,127.62,382.6Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.89,381v1.44h1.94v.72h-1.94v1.18h-.8v-4h3V381Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.31,382.73a1.71,1.71,0,1,1-1.71-1.62A1.66,1.66,0,0,1,141.31,382.73Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,140.52,382.73Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.27,381.17v3.12h-.8v-.2a1.52,1.52,0,0,1-.85.25c-.92,0-1.34-.43-1.34-1.44v-1.73h.8v1.73c0,.49.24.72.68.72a1,1,0,0,0,.71-.25v-2.2Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.4,382.6v1.74h-.8V382.6c0-.49-.24-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.8v-3.12h.8v.19a1.45,1.45,0,0,1,.83-.25C151,381.16,151.4,381.59,151.4,382.6Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.67,380v4.34h-.8v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,2,2,0,0,1,.91.23V380Zm-.8,3.4v-1.26a1.19,1.19,0,0,0-.77-.26.9.9,0,1,0,0,1.79A1.22,1.22,0,0,0,155.87,383.35Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162,381.17v3.12h-.8v-.23a1.58,1.58,0,0,1-.91.28,1.62,1.62,0,0,1,0-3.23,1.76,1.76,0,0,1,.91.26v-.2Zm-.8.93a1.22,1.22,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.19,1.19,0,0,0,.77-.26Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.1,381.83v1.11c0,.55.09.72.49.72a3.7,3.7,0,0,0,.37,0v.59a1.79,1.79,0,0,1-.73.12.9.9,0,0,1-.94-1v-1.53h-.44v-.66h.44V380h.81v1.21H166v.66Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.88,380.41a.47.47,0,0,1,.46-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,167.88,380.41Zm.06.81h.8v3.12h-.8Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.18,382.73a1.71,1.71,0,1,1-1.71-1.62A1.66,1.66,0,0,1,174.18,382.73Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,173.39,382.73Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.16,382.6v1.74h-.8V382.6c0-.49-.24-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.8v-3.12h.8v.19a1.45,1.45,0,0,1,.83-.25C178.74,381.16,179.16,381.59,179.16,382.6Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11.73,
    y1: 373.08,
    x2: 71.42,
    y2: 373.08
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(4.56 375.86)"
  }, "1")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 5.92,
    cy: 373.08,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 11.73,
    y1: 192.48,
    x2: 71.42,
    y2: 192.48
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(3.56 195.26)"
  }, "2")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 5.92,
    cy: 192.48,
    r: 5.67
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(143.95 8.63)"
  }, "3")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.19,
    cy: 5.92,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 146.18,
    y1: 39.14,
    x2: 146.18,
    y2: 11.63
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 87.05,
    y: 39.25,
    width: 110.57,
    height: 43.84
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 307.56,
    y1: 440.79,
    x2: 307.56,
    y2: 286.48
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(305.32 449.17)"
  }, "4")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 307.56,
    cy: 446.46,
    r: 5.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvm3);
export default __webpack_public_path__ + "static/media/ivm3.cafbff4665e0cf4f4b57e42149cd65c0.svg";
export { ForwardRef as ReactComponent };